import { Component, Inject, OnInit } from '@angular/core';
import { SalesStructureTeamService } from '../../../core/services/sales-structure-team.service';
import { BranchService } from '../../../core/services/branch.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Sweetalert2Service } from '../../../core/services/sweetalert2.service';

@Component({
  selector: 'app-modal-team-transfer',
  templateUrl: './modal-team-transfer.component.html',
  styleUrls: ['./modal-team-transfer.component.scss']
})
export class ModalTeamTransferComponent implements OnInit {

  companyId: any;
  teamId: any;
  branchId: any;

  branchs: any = [];
  teams: any = [];
  salesStructureDetails: any = {};

  constructor(private _salesStructureTeamService: SalesStructureTeamService,
              private _branchService: BranchService,
              private _sweetalert2Service: Sweetalert2Service,
              public _dialogRef: MatDialogRef<ModalTeamTransferComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any = {}) { }

  ngOnInit() {

  }

  onGetTeam() {
    if (this.companyId && this.branchId) {
      this._salesStructureTeamService.getSalesStructureTeams(this.companyId).toPromise()
        .then(res => {
          if (res && res.model) {
            this.teams = res.model.filter(i => i.branchId === this.branchId);
          }
        });
    }
  }

  onGetBranch() {
    if (this.companyId) {
      this._branchService.getBranches(this.companyId)
        .then(res => {
          this.branchs = res ?? [];
        });
    }
  }

  onGetTeamById() {
    if (this.companyId && this.branchId && this.teamId) {
      this._salesStructureTeamService.getSalesStructureTeam(this.companyId, this.teamId).toPromise()
        .then(res => {
          if (res && res.model) {
            this.salesStructureDetails = res.model.teams;
          }
        });
    }
  }

  onSetSalesStructureTeam(item) {
    this._sweetalert2Service.withConfirm('ยืนยัน', 'คุณต้องการย้ายทีมใช่หรือไม่ ?')
      .then(confirm => {
        if (confirm) {
          item.forEach(i => i.salesStructureTeamId = this.teamId);

          const formData = {
            id: this.teamId,
            salesStructureTeamDetails: item
          };

          if (this.teamId && this.data.team.id) {
            let _temp = formData.salesStructureTeamDetails.filter(i => {
              if (i.salesPersonCitizenId === this.data.team.sales.citizenId) {
                return i;
              }
            });

            _temp = _temp.filter(i => {
              if (i.supervisorCitizenId !== this.data.team.parent.sales.citizenId) {
                return i;
              }
            });

            _temp.forEach(value => {
              const index = formData.salesStructureTeamDetails.findIndex(i => {
                if (i.salesPersonCitizenId === value.salesPersonCitizenId && i.supervisorCitizenId === value.supervisorCitizenId) {
                  return i;
                }
              });

              if (index > -1) {
                formData.salesStructureTeamDetails.splice(index, 1);
              }
            });
          }

          this._salesStructureTeamService.transferTeam(this.companyId, this.teamId, formData)
            .toPromise()
            .then(res => {
              this._sweetalert2Service.withSuccess('สำเร็จ', 'ทำการย้ายสายงานเรียบร้อย');

              if (this.teamId && this.data.team.id) {
                this._dialogRef.close(res.model);
              }
            })
            .catch(err => console.log(err));
        }
      });
  }

  onClose() {
    this._dialogRef.close(null);
  }
}
